import { render, staticRenderFns } from "./video_6.vue?vue&type=template&id=118484de&scoped=true&"
var script = {}
import style0 from "./video_6.vue?vue&type=style&index=0&id=118484de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118484de",
  null
  
)

export default component.exports